import React from "react";
import Headroom from "react-headroom";

import {
  chakra,
  Box,
  Flex,
  useColorModeValue,
  HStack,
  useDisclosure,
  VStack,
  IconButton,
  CloseButton,
  Icon
} from "@chakra-ui/react";
import { AiOutlineMenu } from "react-icons/ai";
import Button from "./Button";
import {AiOutlineDownload} from "react-icons/ai"
import { Tokens } from "../mirrorful/theme";

export default function NavBar2({id}){


  const bg = useColorModeValue("white", "gray.800");
  const mobileNav = useDisclosure();

  const handleResumeClick = () => {
    const fileName = 'Abhishree_Tripathi_Resume.pdf';
    const fileUrl = process.env.PUBLIC_URL + '/' + fileName;
    const googleDriveLink = 'https://drive.google.com/file/d/1ojIBVdUUGlA73t4zRkAyRWCSgd7HAbAu/view?usp=sharing';

    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    //was 2
    link.id='resume-link-1'
    link.click();

    window.open(googleDriveLink, '_blank');
  };


  const scrollToAbout = () => {
    const aboutSection = document.querySelector("#about");
    const yOffset = -100; // Adjust this value to control the scroll amount
    const y = aboutSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
    
  };

  const verticalScrollToProjects=()=>{
    const ProjectSection = document.querySelector("#projects");
    const yOffset = -500; // Adjust this value to control the scroll amount
    const y = ProjectSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });

  }
  const scrollToProjects = () => {
    const ProjectSection = document.querySelector("#projects");
    const yOffset = -100; // Adjust this value to control the scroll amount
    const y = ProjectSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });

    // ProjectSection.scrollIntoView({ behavior: "smooth" });
  };
  const scrollToHome=()=>{
    const HomeSection=document.querySelector("#home")
    const yOffset = -100; // Adjust this value to control the scroll amount
    const y = HomeSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  const scrollToContact=()=>{
    const ContactSection = document.querySelector("#contact")
    const yOffset = -100; // Adjust this value to control the scroll amount
    const y = ContactSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
  const scrollToSkills=()=>{
    const SkillSection=document.querySelector("#skills")
    const yOffset = -100; // Adjust this value to control the scroll amount
    const y = SkillSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  return (
    // <Headroom id={id}>

<chakra.header

        position="fixed"
        zIndex={10000}
        mt={-7}
      // top={0}
      // backgroundColor={Tokens.background.shades['400']} backdropFilter="saturate(180%) blur(5px)" 
      backgroundColor={Tokens.background.base}
        // zIndex="sticky"
        w="full"
        px={{ base: 2, sm: 4 }}
        py={4}
      >
        <Flex alignItems="center"justifyContent="space-between" mx="auto">
          <Flex>
            <Button handleClick={handleResumeClick} id="resume-button-1" name={"nav-link resume"} label="Resume">
              <Icon as={AiOutlineDownload} marginLeft={"2px"}/>
            </Button>

          </Flex>
          <HStack display="flex" alignItems="center" spacing={1}>
            <HStack
              spacing={4}
              mr={1}
            
              color="brand.500"
              display={{ base: "none", md: "inline-flex" }}
            >
             <a href="#home" onClick={(e)=>{e.preventDefault()}}> <Button name="nav-link home"  label="Home"   variant="ghost" handleClick={scrollToHome}/></a> 
        <a href="#about" onClick={(e)=>{e.preventDefault()}}><Button name="nav-link about" label="About Me"   variant="ghost" handleClick={scrollToAbout}/></a> 
             <a href="#skills" onClick={(e)=>e.preventDefault()}><Button name="nav-link skills" label="Skills"   variant="ghost" handleClick={scrollToSkills}/></a> 
          < a href="#projects" onClick={(e)=>{e.preventDefault()}}>  <Button name="nav-link projects" label="Projects"   variant="ghost" handleClick={scrollToProjects}/></a> 
             <a href="#contact"  onClick={(e)=>{e.preventDefault()}}> <Button name="nav-link contact" label="Contact"  variant="ghost" handleClick={scrollToContact}/></a>
            </HStack>
            {/* <Button colorScheme="brand" size="sm">
              Get Started
            </Button> */}
            <Box display={{ base: "inline-flex", md: "none" }}>
              <IconButton
                display={{ base: "flex", md: "none" }}
                aria-label="Open menu"
                fontSize="20px"
                color="gray.800"
                _dark={{ color: "inherit" }}
                variant="ghost"
                icon={<AiOutlineMenu />}
                onClick={mobileNav.onOpen}
              />

              <VStack
              pos={"absolute"}
              zIndex={10000}
                top={0}
                left={0}
                right={0}
                display={mobileNav.isOpen ? "flex" : "none"}
                flexDirection="column"
                p={2}
                pb={10}
                m={2}
                bg={"black"}
                spacing={3}
                rounded="sm"
                shadow="sm"
                
              >
                <CloseButton
                  aria-label="Close menu"
                  onClick={mobileNav.onClose}
                  
                />

                <Button label="Home"  w="full" variant="ghost" handleClick={scrollToHome}/>
                <Button label="About Me"  w="full" variant="ghost" handleClick={scrollToAbout}/>
                <Button label="Skills" w="full" variant="ghost"  handleClick={scrollToSkills}/>
                <Button label="Projects"  w="full" variant="ghost" handleClick={verticalScrollToProjects}/>
                <Button label="Contact" w="full" variant="ghost" handleClick={scrollToContact}/>
              </VStack>
            </Box>
          </HStack>
        </Flex>
      </chakra.header>
   
  );
};
